export const changeVersionNumberReducer = (state = 2, action) => {
  switch (action.type) {
    case "CHANGE_versionNumber":
      return action.payload.versionNumber;
    default:
      return state;
  }
};
